// src/hooks/useLivekit.js
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { setSessionData } from '../store/auth';

 const useAuth = () => {
    const dispatch = useDispatch();

    // Selector to get state parts
    const token = useSelector((state) => state.auth.token);
   
    // Action dispatchers
    const setSessionDataAction = useCallback((params) => {
        dispatch(setSessionData(params));
    }, [dispatch]);

   

    return {
        token,
        setSessionDataAction,
    };
};
export default useAuth;